export default "__VITE_PUBLIC_ASSET__8e45d77c__"